import React, { useEffect , useState} from "react";
import logo from "../../assets/images/TT Logo Bug.png"
import logoFypon from "../../assets/images/Fypon Logo Bug.png"


export default function LogoComponent() {

    return(
        <div className="logo_div">

            <img src={logo} id="thermatru-logo" className="logo-cls w-100" alt=""/>
            <img src={logoFypon} id="fypon-logo"  className="logo-cls w-100 d-none" alt=""/>

        </div>
    )
}